import { render, staticRenderFns } from "./waterMaster07Detail.vue?vue&type=template&id=c6fda1bc"
import script from "./waterMaster07Detail.vue?vue&type=script&lang=js"
export * from "./waterMaster07Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6fda1bc')) {
      api.createRecord('c6fda1bc', component.options)
    } else {
      api.reload('c6fda1bc', component.options)
    }
    module.hot.accept("./waterMaster07Detail.vue?vue&type=template&id=c6fda1bc", function () {
      api.rerender('c6fda1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/mst/waterMaster07Detail.vue"
export default component.exports